import type { McpCatalogResponseDto } from '@inference.engine/api-client/web';

export type McpAuthType = McpCatalogResponseDto['authType'];

export const AUTH_TYPE_LABEL_KEY = {
  static_headers: 'admin.mcpCatalogPanel.staticHeaders',
  no_auth: 'admin.mcpCatalogPanel.noAuth',
  oauth: 'admin.mcpCatalogPanel.oauth',
} as const satisfies Record<McpAuthType, string>;

export const AUTH_TYPE_OPTIONS = [
  'static_headers',
  'no_auth',
  'oauth',
] as const satisfies readonly McpAuthType[];
